/**
 * King in words (review 0026): the game tile, the games a chooser may name, the seats, the toasts
 * and why a card was refused. Apart, so each language file stays in budget.
 */
export const kingEn = {
  "variant.king": "King",
  "variant.king.tag": "Solo · penalties + trump",
  "variant.king.blurb":
    "Solo, 20 hands: whoever's turn it is names the game, six penalty games or a trump. Highest score wins.",
  "king.game.noTricks": "No tricks",
  "king.game.noHearts": "No hearts",
  "king.game.noBoys": "No kings or jacks",
  "king.game.noQueens": "No queens",
  "king.game.lastTwo": "Last two",
  "king.game.rifki": "King of hearts",
  "king.game.trump": "Trump",
  "king.price.noTricks": "−50 a trick",
  "king.price.noHearts": "−30 a heart",
  "king.price.noBoys": "−60 each",
  "king.price.noQueens": "−100 each",
  "king.price.lastTwo": "−180 each",
  "king.price.rifki": "−320",
  "king.price.trump": "+50 a trick",
  "king.choose.title": "Name the game",
  "king.choose.rights": "Yours: trump {trumps} · penalty {penalties}",
  "king.choose.left": "{count} left",
  "king.choose.gone": "{game}: played twice already",
  "king.choose.noRight": "{game}: you have none left",
  "king.choose.suit": "Which suit is trump?",
  "king.choose.back": "Back",
  "king.seat.choose": "Name the game",
  "king.seat.choosing": "Choosing…",
  "king.seat.hand": "{points} this hand",
  "king.bar.trump": "Trump {suit}",
  "king.event.chosen": "{name}: {game}",
  "king.event.cut": "{game}: nothing left to take, the hand is over",
  "king.handEnd.title": "Hand {hand} · {game}: you {points}",
  "king.handEnd.watch": "Hand {hand} · {game}",
  "king.end.out": "Out",
  "king.end.sunk": "Sunk",
  "error.give-penalty": "A higher card is out: you must give that card.",
  "error.discard-penalty": "You are out of that suit: you must throw a penalty card.",
  "error.contract-not-available": "That game cannot be chosen now.",
};

type KingKey = keyof typeof kingEn;

export const kingTr: Record<KingKey, string> = {
  "variant.king": "King",
  "variant.king.tag": "Tekli · ceza + koz",
  "variant.king.blurb":
    "Tekli, 20 el: sırası gelen oyunu seçer, altı ceza ya da koz. En yüksek puan kazanır.",
  "king.game.noTricks": "El almaz",
  "king.game.noHearts": "Kupa almaz",
  "king.game.noBoys": "Erkek almaz",
  "king.game.noQueens": "Kız almaz",
  "king.game.lastTwo": "Son iki",
  "king.game.rifki": "Rıfkı",
  "king.game.trump": "Koz",
  "king.price.noTricks": "el başına −50",
  "king.price.noHearts": "kupa başına −30",
  "king.price.noBoys": "her biri −60",
  "king.price.noQueens": "her biri −100",
  "king.price.lastTwo": "her biri −180",
  "king.price.rifki": "−320",
  "king.price.trump": "el başına +50",
  "king.choose.title": "Oyunu seç",
  "king.choose.rights": "Hakkın: koz {trumps} · ceza {penalties}",
  "king.choose.left": "{count} kaldı",
  "king.choose.gone": "{game}: masada hakkı bitti",
  "king.choose.noRight": "{game}: hakkın kalmadı",
  "king.choose.suit": "Koz hangi renk?",
  "king.choose.back": "Geri",
  "king.seat.choose": "Oyunu seç",
  "king.seat.choosing": "Seçiyor…",
  "king.seat.hand": "Bu el {points}",
  "king.bar.trump": "Koz {suit}",
  "king.event.chosen": "{name}: {game}",
  "king.event.cut": "{game}: alınacak kart kalmadı, el bitti",
  "king.handEnd.title": "{hand}. el · {game}: {points}",
  "king.handEnd.watch": "{hand}. el · {game}",
  "king.end.out": "Çıktı",
  "king.end.sunk": "Battı",
  "error.give-penalty": "Yerde büyüğü var: o kartı vermek zorundasın.",
  "error.discard-penalty": "O renk elinde yok: ceza kartı atmalısın.",
  "error.contract-not-available": "Bu oyun şu an seçilemez.",
};

/** Draft, like the rest of the Arabic dictionary: waits for a native check (review 0021). */
export const kingAr: Record<KingKey, string> = {
  "variant.king": "كينغ",
  "variant.king.tag": "فردي · عقوبات + حكم",
  "variant.king.blurb":
    "فردي، 20 جولة: صاحب الدور يختار اللعبة، ست عقوبات أو حكم. يفوز صاحب أعلى نقاط.",
  "king.game.noTricks": "بلا لمّات",
  "king.game.noHearts": "بلا قلوب",
  "king.game.noBoys": "بلا شيّاب ولا أولاد",
  "king.game.noQueens": "بلا بنات",
  "king.game.lastTwo": "آخر لمّتين",
  "king.game.rifki": "شايب القلوب",
  "king.game.trump": "حكم",
  "king.price.noTricks": "−50 لكل لمّة",
  "king.price.noHearts": "−30 لكل قلب",
  "king.price.noBoys": "−60 لكل ورقة",
  "king.price.noQueens": "−100 لكل ورقة",
  "king.price.lastTwo": "−180 لكل لمّة",
  "king.price.rifki": "−320",
  "king.price.trump": "+50 لكل لمّة",
  "king.choose.title": "اختر اللعبة",
  "king.choose.rights": "لك: حكم {trumps} · عقوبة {penalties}",
  "king.choose.left": "بقي {count}",
  "king.choose.gone": "{game}: لُعبت مرتين",
  "king.choose.noRight": "{game}: لم يبق لك منها",
  "king.choose.suit": "أي لون هو الحكم؟",
  "king.choose.back": "رجوع",
  "king.seat.choose": "اختر اللعبة",
  "king.seat.choosing": "يختار…",
  "king.seat.hand": "{points} في هذه الجولة",
  "king.bar.trump": "الحكم {suit}",
  "king.event.chosen": "{name}: {game}",
  "king.event.cut": "{game}: لم يبق ما يؤخذ، انتهت الجولة",
  "king.handEnd.title": "الجولة {hand} · {game}: {points}",
  "king.handEnd.watch": "الجولة {hand} · {game}",
  "king.end.out": "نجا",
  "king.end.sunk": "غرق",
  "error.give-penalty": "هناك ورقة أعلى: يجب أن تعطي تلك الورقة.",
  "error.discard-penalty": "ليس لديك هذا اللون: يجب أن ترمي ورقة عقوبة.",
  "error.contract-not-available": "لا يمكن اختيار هذه اللعبة الآن.",
};
